import { render, staticRenderFns } from "./ClubFollowersAdmin.vue?vue&type=template&id=1e98afdd&"
import script from "./ClubFollowersAdmin.controller.js?vue&type=script&lang=js&"
export * from "./ClubFollowersAdmin.controller.js?vue&type=script&lang=js&"
import style0 from "./ClubFollowersAdmin.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports